import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWarehouseModel } from "../warehouseModel";
import { IVRMWarehouseDetail } from "../warehouseTypes";
import useGlobalModel from "@/model/globalModel";
import { momentFormat } from "@/utils/utils";

const columns: ColumnsType<IVRMWarehouseDetail> = [
    {
        title: '序号',
        width: 60,
        align: "center",
        fixed: "left",
        render: (t, r, i) => <>{i + 1}</>
    },
    {
        title: '仓库编码',
        width: 180,
        align: "center",
        dataIndex: 'code',
        fixed: "left",
    },
    {
        title: '仓库名称',
        width: 180,
        align: "center",
        dataIndex: 'name',
        fixed: "left",
    },
    // {
    //     title: '仓库类型',
    //     width: 180,
    //     align: "center",
    //     dataIndex: 'code',
    //     fixed: "left",
    // },
    {
        title: '仓库负责人',
        align: "center",
        dataIndex: 'contact',
    },
    {
        title: '联系地址',
        align: "center",
        dataIndex: 'address',
    },
    {
        title: '联系电话',
        align: "center",
        dataIndex: 'phone',
    },
    {
        title: '创建人',
        align: "center",
        dataIndex: 'createUser',
    },
    {
        title: '创建时间',
        align: "center",
        dataIndex: 'createTime',
    },
    {
        title: '仓库状态',
        align: "center",
        dataIndex: 'status',
        render: (t: any, r: any, i: number) => <span>{t?'启用':'禁用'}</span>,
    }
];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useWarehouseModel();

    useEffect(() => {
        loadData();
        setSelectedRowKeys('');
    }, [])

    return (
        <Table
        bordered
            size='large'
            rowKey={record => record.id as string}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                // ...pgCfg, 
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            onRow={record => ({
                onClick: event => setSelectedRowKeys(selectedRowKeys === record.id as string ? "" : record.id as string)
            })}
            rowClassName={(record, index) => record.id === selectedRowKeys ? "table-select-row" : ""}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)"  }}
        />
    )
}
